// extracted by mini-css-extract-plugin
module.exports = {"root":"all-activities_root__2OWz8","cardEditable":"all-activities_cardEditable__1_o7f"};